import LoLExamRoomLayout from './LoLExamRoomLayout';

export default LoLExamRoomLayout;
